import styled from "styled-components";

import { BREAKPOINT, CARD_BACKGROUND, COLORS } from "../../../constants/Styles";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

const Label = styled.label`
  display: block;
  padding: 0.25rem;
  position: sticky;
  top: 0;
  color: ${COLORS.secondaryLight};

  ${CARD_BACKGROUND};
`;

const ResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  @media (max-width: ${BREAKPOINT}) {
    flex-direction: column;
  }
`;

export { Container, Label, ResultsContainer };
